import { forwardRef } from "react";
import { useDrop } from "react-dnd";
import { NativeTypes } from "react-dnd-html5-backend";

import Utils from "pages/common/lib/grabyo-util";
import { Wrapper, Input, InputLabel } from "./input.styles";

const DropTarget = forwardRef<
    unknown,
    { name?: string; onFiles: (files: File[]) => void; multiple?: boolean }
>(function DropTarget({ children, name, onFiles, multiple }, ref) {
    const [{ isOver }, drop] = useDrop({
        accept: NativeTypes.FILE,
        drop: ({ files }) => onFiles(files),
        collect: (monitor) => ({
            isOver: monitor.isOver()
        })
    });

    const id = Utils.generateGrabyoId(5);
    const onInput = ({
        target,
        target: { files }
    }: {
        target: { files: FileList; value: string };
    }) => {
        if (files.length > 0) onFiles(Array.from(files));
        target.value = ``;
    };

    return (
        <Wrapper isOver={isOver} ref={drop}>
            <Input
                type="file"
                multiple={multiple}
                name={name}
                id={`${id}-uploader`}
                onChange={onInput}
                //@ts-ignore: requires input migration
                ref={ref}
            />
            <InputLabel isOver={isOver} htmlFor={`${id}-uploader`}>
                {children}
            </InputLabel>
        </Wrapper>
    );
});

export default DropTarget;
